"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const insuranceCoverage_1 = require("../../insuranceCoverage");
const assured_1 = __importDefault(require("../../assured"));
const insuranceCoverage_2 = __importDefault(require("../../insuranceCoverage/insuranceCoverage"));
const paymentMethod_1 = __importDefault(require("../../payments/paymentMethod"));
const shipmentContact_1 = __importDefault(require("../../shipmentContact"));
const shipment_1 = __importDefault(require("../../shipment"));
const user_1 = __importDefault(require("../../user"));
class InsuranceCertificatePurchaseRequest {
    constructor(user, coverage, assured, shipment, channel, shipmentContact, paymentMethod, sendEmailsTo, callback, quoteId, underwriting, accountId, authorizedUsers) {
        this.user = user;
        this.coverage = coverage;
        this.assured = assured;
        this.shipment = shipment;
        this.channel = channel;
        this.shipmentContact = shipmentContact;
        this.paymentMethod = paymentMethod;
        this.sendEmailsTo = sendEmailsTo;
        this.callback = callback;
        this.quoteId = quoteId;
        this.underwriting = underwriting;
        this.accountId = accountId;
        this.authorizedUsers = authorizedUsers;
    }
    static fromObj(data) {
        const user = user_1.default.fromObj(data.user);
        const coverage = insuranceCoverage_2.default.fromObj(data.coverage);
        const assured = assured_1.default.fromObj(data.assured);
        const shipmentContact = shipmentContact_1.default.fromObj(data.shipmentContact);
        const shipment = shipment_1.default.fromObj(data.shipment);
        const paymentMethod = paymentMethod_1.default.fromObj(data.paymentMethod);
        if (!paymentMethod) {
            throw new Error("Unknown payment method");
        }
        const callback = (data === null || data === void 0 ? void 0 : data.callback)
            ? insuranceCoverage_1.Callback.fromObj(data.callback)
            : undefined;
        const sendEmailsTo = Array.isArray(data === null || data === void 0 ? void 0 : data.sendEmailsTo)
            ? data === null || data === void 0 ? void 0 : data.sendEmailsTo
            : [];
        const { underwriting } = data;
        const authorizedUsers = Array.isArray(data === null || data === void 0 ? void 0 : data.authorizedUsers)
            ? data === null || data === void 0 ? void 0 : data.authorizedUsers
            : [];
        return new InsuranceCertificatePurchaseRequest(user, coverage, assured, shipment, data.channel, shipmentContact, paymentMethod, sendEmailsTo, callback, data.quoteId, underwriting, data.accountId, authorizedUsers);
    }
}
exports.default = InsuranceCertificatePurchaseRequest;
//# sourceMappingURL=insuranceCertificatePurchaseRequest.class.js.map